import React from 'react'
import { IMaskInput } from 'react-imask';

const TextMaskIdCard = React.forwardRef(
    function TextMaskIdCard(props, ref) {
        const { onChange, ...other } = props;
        return (
            <div>
                <IMaskInput
                    {...other}
                    mask="0-0000-00000-00-0"
                    // mask="000-000000-0"
                    definitions={{ "#": /[1-9]/ }}
                    inputRef={ref}
                    onAccept={(value) => onChange({ target: { name: props.name, value } })}
                    overwrite
                />
                {/* {props.testA} */}
            </div>
        );
    }
);
export default TextMaskIdCard;
